import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  MenuItem
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { InputAdornment, IconButton } from "@material-ui/core";



const ApiKeyModal = ({ open, onClose, apiKeyId, refreshApiKeys }) => {
  const [name, setName] = useState("");
  const [key, setKey] = useState("");
  const [type, setType] = useState("openai");
  const [showKey, setShowKey] = useState(false);

  useEffect(() => {
    const fetchApiKey = async () => {
      if (!apiKeyId) return;

      try {
        const { data } = await api.get(`/apikey/${apiKeyId}`);
        setName(data.name);
        setKey(data.key);
        setType(data.type);
      } catch (err) {
        toastError(err);
      }
    };

    fetchApiKey();
  }, [apiKeyId]);

  const handleClose = () => {
    setName("");
    setKey("");
    setType("openai");
    onClose();
  };

  const handleSave = async () => {
    const apiKeyData = { name, key, type };

    try {
      if (apiKeyId) {
        await api.put(`/apikey/${apiKeyId}`, apiKeyData);
      } else {
        await api.post("/apikey", apiKeyData);
      }
      refreshApiKeys();
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {apiKeyId
          ? i18n.t("apiKey.modal.editTitle")
          : i18n.t("apiKey.modal.addTitle")}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label={i18n.t("apiKey.modal.name")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="dense"
        />
        <TextField
          label={i18n.t("apiKey.modal.key")}
          type={showKey ? "text" : "password"}
          value={key}
          onChange={(e) => setKey(e.target.value)}
          fullWidth
          margin="dense"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowKey((prev) => !prev)}>
                  {showKey ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <TextField
          select
          label={i18n.t("apiKey.modal.type")}
          value={type}
          onChange={(e) => setType(e.target.value)}
          fullWidth
          margin="dense"
        >
          <MenuItem value="openai">OpenAI</MenuItem>
          <MenuItem value="custom">Custom</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {i18n.t("apiKey.modal.cancel")}
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          {i18n.t("apiKey.modal.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApiKeyModal;